import type { FieldType, IQuoteTextLine } from '@/interfaces'

import { addToJSON } from './helper'

export class QuoteTextLine implements IQuoteTextLine {
	[key: string]: FieldType
	textLineId: number
	quoteLineId: number
	lineNum: number
	text: string
	afterLineNumber: number
	isDeleted: boolean

	// Required for IRecord
	id: number | string

	constructor({
		textLineId,
		id,
		quoteLineId,
		lineNum,
		lineNumber, // legacy field for backwards compatibility
		text,
		lineText, // legacy field
		afterLineNumber,
		isDeleted
	}: Partial<IQuoteTextLine & { lineNumber?: number; lineText?: string }> = {}) {
		this.textLineId = textLineId || 0
		this.id = id || textLineId || 0
		this.quoteLineId = quoteLineId || 0
		this.lineNum = lineNum || 0
		this.text = String(lineText || text || '')
		this.afterLineNumber = afterLineNumber || 0
		this.isDeleted = isDeleted || false

		addToJSON(QuoteTextLine)
	}

	public isEmpty(): boolean {
		return !this.text || this.text.trim().length === 0
	}

	public getDisplayText(): string {
		return this.text || ''
	}

	public updateText(newText: string): void {
		this.text = newText || ''
	}
}
